<template>
  <div class="front-page-body">
    <div class="header-container">
      <!--      <div class="item-choose">-->
      <!--        <div class="item item-selected">漫画</div>-->
      <!--        <div class="item item-novel" @click="onToNovelPage">小说</div>-->
      <!--      </div>-->
      <div class="search-box-container">
        <SearchBoxIcon itemType="comic"></SearchBoxIcon>
      </div>
    </div>

    <div v-if="isLoading">
      <LoadingComponent></LoadingComponent>
    </div>

    <div v-if="!isLoading" class="main-body">
      <div v-for="item in pageItemList" :key="item.id">
        <div v-if="item.unit_type === 2">
          <BannerList :bannerList="item.item" v-if="item.item && item.item.length > 0"></BannerList>
        </div>
        <div v-if="item.unit_type === 5" class="shortcut-container">
          <ShortCutComponent :dataList="item.item" v-if="item.item && item.item.length > 0"></ShortCutComponent>
        </div>
        <div v-if="item.unit_type === 4">
          <TabList :dataList="item.item" v-if="item.item && item.item.length > 0" :config="item.config"></TabList>
        </div>
      </div>
    </div>

    <TabbarComponent></TabbarComponent>
  </div>
</template>

<script>
  import BannerList from "../../common/BannerList";
  import SearchBoxIcon from "../../common/SearchBoxIcon";
  import {Tab, Tabs, Icon, Popup, Button} from "vant"
  import LoadingComponent from "../../common/LoadingComponent";
  import TabList from "../../common/TabList";
  import ShortCutComponent from "../../common/ShortCutComponent";
  import TabbarComponent from "../../common/TabbarComponent";

  export default {
    name: "ComicFrontPage",
    components: {
      TabbarComponent,
      ShortCutComponent,
      Icon,
      TabList,
      LoadingComponent,
      Tab,
      Tabs,
      SearchBoxIcon,
      BannerList,
      Popup,
      Button,
    },
    data() {
      return {
        isLoading: true,
        userInfo: {},
        showBaseInfo: false,
        dotNotification: false,
      }
    },
    mounted() {
      this.initFrontPage()
    },

    activated() {
      this.initUserInfo()
    },

    methods: {
      initUserInfo() {
        this.$store.dispatch("AccountInfoMine").then((data) => {
          if (data.code === 0) {
            this.userInfo = data.data
            this.avatarUrl = this.userInfo.avatar_url
          }
        }, () => {
        })
      },

      initFrontPage() {
        let params = {
        }
        if (this.$route.query.utm_source) {
          params.utm_source = this.$route.query.utm_source
        }
        this.$store.dispatch("FeedFrontPageComic", params).then((data) => {
          if (data.code === 0) {
            this.pageItemList = data.data
            this.isLoading = false
          }
        }, () => {
        })
      },
    },
    computed: {
    }
  }
</script>

<style lang="scss" scoped>
  .front-page-body {
    background: #fafafa;
  }

  .icon-list {
    background: white;
    padding: 12px 20px;
    display: flex;
    align-items: center;
  }

  .content-list {
    background: white;
    margin-top: 5px;
    min-height: 50vh;

    .content-title {
      padding: 8px 13px;
      border-left: solid 3px blue;
    }
  }

  .header-container {
    padding: 12px 12px;
    background: white;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .item-choose {
      display: flex;
      align-items: center;
      color: #4e4e4e;

      .item-selected {
        background: #ffbb31;
        color: white;
        border: 1px solid gold;
      }

      .item{
        padding: 3px 8px;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        border-radius: 3px;
      }

      .item-novel {
        margin-left: 8px;
      }
    }

    .search-box-container {
      flex: 1 1 auto;
      padding: 0 12px;
    }
  }

  .user-avatar {
    flex: 0 0 auto;
    width: 35px;
    height: 35px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    background: white;
    overflow: hidden;
    border: 1px solid #f2f2f2;

    img {
      height: 100%;
    }
  }

  .banner-list {
    background: white;
    padding: 12px 15px;
  }

  .icon-bookshelf {
    /*border-bottom: solid 2px #fc9153;*/
    border: solid 1px #fc9153;
    padding: 2px;
    font-size: 14px;
    color: #fc9153;
    -webkit-border-radius: 2px;
    -moz-border-radius: 2px;
    border-radius: 2px;
    line-height: 1.2;
  }

  .notification-icon-box {
    font-size: 20px;
  }

  .img-not-available {
    background: white;
    padding: 8px;

    img {
      width: 100%;
    }
  }

  .login-tip {
    text-align: center;
    background: white;
    padding: 24px;
    font-size: 18px;
    color: grey;
  }

  .main-body {
    position: relative;
  }

  .cover-box-container {
    position: fixed;
    z-index: 1002;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 63px;
    background: rgba(0, 0, 0, 0.91);

    .cover-box-desc {
      color: white;
      font-size: 18px;
      padding: 22px 0;
      text-align: center;
    }

    .pay-box {
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;
    }
  }

  .shortcut-container {
    background: white;
    padding: 18px 0;
  }

  .cover-box-follow-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: white;

    .follow-tip {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding: 65px 0;
      color: rgba(0, 78, 0, 0.76);
      .icon {
        font-size: 64px;
      }
      .desc {
        margin-top: 12px;
        font-size: 22px;
      }
      .btn {
        margin-top: 24px;
      }
    }
  }

</style>

